/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import axios from 'axios';

export class SendLinkFunctionParams {
    constructor(
        type,
        sapcode,
        value,
        ffcDomain,
        ffcSMSPath,
        ffcEmailPath,
        locale,
        adobeAppId,
        accessToken,
        successCb,
        failureCb,
        templateParameters = {},
        timeout = 3000,
        xApiKey = '',
        xWorkFlowId = '',
        template,
    ) {
        this.type = type;
        this.sapcode = sapcode;
        this.value = value;
        this.ffcDomain = ffcDomain;
        this.ffcSMSPath = ffcSMSPath;
        this.ffcEmailPath = ffcEmailPath;
        this.locale = locale;
        this.adobeAppId = adobeAppId;
        this.accessToken = accessToken;
        this.successCb = successCb;
        this.failureCb = failureCb;
        this.template = template;
        this.templateParameters = templateParameters;
        this.timeout = timeout;
        this.xApiKey = xApiKey;
        this.xWorkFlowId = xWorkFlowId;
    }
}

export function sendLink(
    sendLinkFunctionObj
) {
    const {
        type,
        sapcode,
        value,
        ffcDomain,
        ffcSMSPath,
        ffcEmailPath,
        locale,
        adobeAppId,
        accessToken,
        successCb,
        failureCb,
        template,
        templateParameters,
        timeout,
        xApiKey,
        xWorkFlowId,
    } = sendLinkFunctionObj;
    const sendLinkAxios = axios.create({
        baseURL: ffcDomain,
        timeout,
        headers: {
            'x-adobe-app-id': adobeAppId,
            Authorization: `Bearer ${accessToken}`,
        },
    });
    if (xApiKey) {
        sendLinkAxios.defaults.headers.common['x-api-key'] = xApiKey;
    }
    if (xWorkFlowId) {
        sendLinkAxios.defaults.headers.common['x-workflow-id'] = xWorkFlowId;
    }

    if (type === 'sms') {
        const smsData = {
            phoneNumber: value,
            locale,
            mobileAppCode: sapcode,
            templateParameters,
        };
        sendLinkAxios.post(ffcSMSPath, smsData)
            .then(successCb)
            .catch(failureCb);
    }
    if (type === 'email') {
        const emailData = {
            emailId: value,
            locale,
            mobileAppCode: sapcode,
            templateParameters,
        };
        sendLinkAxios.post(ffcEmailPath, emailData)
            .then(successCb)
            .catch(failureCb);
    }
    if (type === 'email_desktop') {
        const emailData = {
            emailId: value,
            locale,
            template,
            templateParameters,
        };
        sendLinkAxios.post(ffcEmailPath, emailData)
            .then(successCb)
            .catch(failureCb);
    }
}
